module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('industry-single', {
    scopedSlots: _vm._u([{
      key: "hero",
      fn: function() {
        return [_c('hero-full', {
          attrs: {
            "imageName": "industries/construction-banner.jpg",
            "altText": "Man next to the construction vehicle"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h1', [_vm._v("Commercial Construction Loans")]), _vm._v(" "), _c('p', [_vm._v("Construction Business Financing & Equipment Loans")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "form-section",
      fn: function() {
        return [_c('FormSection', {
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_c('span', [_vm._v("American Credit:")]), _vm._v(" Empowering Construction owners\n          everyday.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          You’ve done everything right with your construction business, but\n          then life happens. Whether it be needing quick financing to fund a\n          lucrative sudden project, or immediate funding to meet payroll,\n          we’ve got your back. American Credit understands construction owners\n          and their need for immediate financing in an ever-changing world.\n          Read on and see how we help construction owners everyday.\n        ")])]
            },
            proxy: true
          }, {
            key: "logos",
            fn: function() {
              return [_c('div', {
                staticClass: "row"
              }, [_c('div', {
                staticClass: "col-12 col-md-5 order-md-2 d-flex"
              }, [_c('div', {
                staticClass: "row align-items-center logos-brands"
              }, [_c('div', {
                staticClass: "col-6 col-md-12"
              }, [_c('img', {
                attrs: {
                  "src": "/static/assets/imgs/industries/nefa-logo.png",
                  "alt": "NEFA logo"
                }
              })]), _vm._v(" "), _c('div', {
                staticClass: "col-6 col-md-12"
              }, [_c('a', {
                attrs: {
                  "href": "https://www.bbb.org/us/ca/palo-alto/profile/financial-services/american-credit%C2%AE-inc-1216-1079741",
                  "target": "_blank"
                }
              }, [_c('img', {
                attrs: {
                  "src": "/static/assets/imgs/industries/bbba-logo.png",
                  "alt": "BBBA logo"
                }
              })])])])]), _vm._v(" "), _c('div', {
                staticClass: "col-12 col-md-7"
              }, [_c('img', {
                attrs: {
                  "src": "/static/assets/imgs/industries/google-review.png",
                  "alt": "Google Review"
                }
              })])])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "first-row",
      fn: function() {
        return [_c('RowSection', {
          attrs: {
            "img-side": "left",
            "imageName": "industries/construction-equipment-loans.jpg",
            "altText": "Construction machine",
            "backgroundPrimary": "#00234D",
            "backgroundSecondary": "#F6F9FE"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_vm._v("Instant Construction Equipment Loans")]), _vm._v(" "), _c('p', [_vm._v("\n          Use your Construction Equipment Loan to purchase any needed\n          construction equipment, such as forklifts, excavators, skid steers,\n          track loaders, telehandlers & more! When you talk with our lending\n          experts, you will be speaking to lending experts who are extremely\n          knowledgeable about the construction industry’s pain points."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n          American Credit understands the difficulties construction business\n          owners face. We work with you to understand your unique construction\n          equipment needs, and then secure quick funding so you can get back\n          to work.\n        ")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "second-row",
      fn: function() {
        return [_c('RowSection', {
          attrs: {
            "img-side": "right",
            "imageName": "industries/construction-working-capital.jpg",
            "altText": "Construction Worker"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_vm._v("Construction Working Capital Solutions")]), _vm._v(" "), _c('p', [_vm._v("\n          Maybe you received a sudden lucrative project, but can’t wait for\n          delayed financing? Or maybe you need to purchase immediate supplies,\n          as well as meet employee payroll? American Credit can fix any\n          short-term or long-term financial difficulties you are facing. Call\n          us to find out what working capital options are available to fix any\n          situation your construction business faces.\n        ")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "third-row",
      fn: function() {
        return [_c('IconsGrid', {
          attrs: {
            "gridElements": _vm.gridItems
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function() {
              return [_vm._v("Geared to Your Needs and Your Business")]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "fourth-row",
      fn: function() {
        return [_c('TablesSection', {
          attrs: {
            "tables": _vm.tableItems
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function() {
              return [_vm._v("Construction Loan Requirements")]
            },
            proxy: true
          }, {
            key: "text",
            fn: function() {
              return [_vm._v("Minimum loan requirements to expedite approval & secure quick\n        funding.")]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "fifth-row",
      fn: function() {
        return [_c('RowSection', {
          staticClass: "lei-section",
          attrs: {
            "img-side": "right",
            "imageName": "industries/Lei-li-formal.jpeg",
            "altText": "photo Dr. Lei Li, CEO of American Credit, Inc., in blue suit smiling"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_c('span', [_vm._v("American Credit:")]), _vm._v(" The Difference You Can Trust")]), _vm._v(" "), _c('p', [_vm._v("\n          Your business is not JUST a business. It’s YOURS. It’s your\n          livelihood. It’s your passion. American Credit completely\n          understands this. We help business owners just like you everyday, by\n          taking a wholistic approach to business financing.\n          "), _c('strong', [_vm._v("Dr. Lei Li, PhD, CFA, & CEO of American Credit")]), _vm._v(", is\n          an Economist who uses his 20+ years of industry experience to help\n          business owners achieve their American Dream:\n          "), _c('strong', [_vm._v("successful business ownership")]), _vm._v(". "), _c('br'), _c('br'), _vm._v("\n          Whatever financial situation you’re in, American Credit has your\n          back. Apply for your business loan today!\n        ")])]
            },
            proxy: true
          }, {
            key: "button-contact",
            fn: function() {
              return [_c('contact-info', {
                staticClass: "d-none d-md-flex",
                attrs: {
                  "imageName": "Lei_Li.png",
                  "altText": "Lei's photo",
                  "title": "Call Lei",
                  "contactType": "Service",
                  "phoneNumber": "650-885-8055"
                }
              })]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "google-reviews",
      fn: function() {
        return [_c('div', {
          staticClass: "elfsight-app-8279c03d-9a65-4465-b949-ecb8d18697e0"
        })]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d912897"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/industries/commercialConstructionLoans.vue
// module id = 1996
// module chunks = 5